import React from 'react';
import { motion } from 'framer-motion';
interface SectionWrapperProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
}
export const SectionWrapper: React.FC<SectionWrapperProps> = ({
  children,
  className = '',
  id
}) => {
  return <motion.section id={id} initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.6,
    ease: 'easeOut'
  }} className={`w-full ${className}`} data-id="element-337">
      {children}
    </motion.section>;
};